<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Recompensas</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Recompensas</div>
        </div>
      </div>

      <div class="appui-tabs">
        <button :class="{ 'is-active': activeTab === 'recompensas' }" @click="activeTab = 'recompensas'"><i class="bx bx-medal" style="margin-right:5px"></i>Recompensas</button>
        <button :class="{ 'is-active': activeTab === 'indicacoes' }" @click="switchTab('indicacoes')"><i class="bx bx-user-plus" style="margin-right:5px"></i>Indicações</button>
      </div>

      <!-- RECOMPENSAS -->
      <template v-if="activeTab === 'recompensas'">
        <div v-if="!rewards.length" class="appui-emptystate">
          <div class="appui-emptystate-icon"><i class="bx bx-medal"></i></div>
          <div class="appui-emptystate-title">Nenhuma recompensa ainda</div>
          <div class="appui-emptystate-sub">Premie quem indica novos participantes — defina a meta de indicações e o prêmio desbloqueado.</div>
          <button class="appui-btn appui-btn--primary" @click="openCreate()">+ Criar a primeira recompensa</button>
        </div>

        <section v-else class="appui-card appui-card--flush">
          <div class="appui-card-toolbar">
            <div class="appui-card-toolbar-left">
              <span class="appui-toolbar-hint"><i class="mdi mdi-information-outline"></i> O participante desbloqueia a recompensa ao atingir a meta de indicações.</span>
            </div>
            <div class="appui-card-toolbar-right">
              <button class="appui-btn appui-btn--primary" @click="openCreate()">+ Nova recompensa</button>
            </div>
          </div>
          <table class="appui-table">
            <thead><tr><th>Recompensa</th><th style="width:150px">Meta</th><th style="width:140px">Disponíveis</th><th style="width:90px">Link</th><th style="width:80px">Ativa</th><th style="width:150px;text-align:right">Ações</th></tr></thead>
            <tbody>
              <tr v-for="r in rewards" :key="r.id">
                <td>
                  <div style="display:flex;align-items:center;gap:10px">
                    <span class="appui-icon-chip"><i class="bx bx-medal"></i></span>
                    <span style="font-weight:500;color:#495057">{{ r.title }}</span>
                  </div>
                </td>
                <td><span class="appui-badge appui-badge--blue">{{ r.target }} {{ r.target > 1 ? 'indicações' : 'indicação' }}</span></td>
                <td style="color:#74788d">{{ r.qty_rewards > 0 ? r.qty_rewards : 'Ilimitado' }}</td>
                <td><a v-if="r.url_reward" :href="r.url_reward" target="_blank" rel="noopener" class="appui-tbtn appui-tbtn--primary" style="text-decoration:none"><i class="mdi mdi-open-in-new"></i></a><span v-else style="color:#adb5bd">—</span></td>
                <td><button class="appui-switch" :class="{ 'is-on': r.status }" @click="toggle(r)"><span class="knob"></span></button></td>
                <td style="text-align:right;white-space:nowrap">
                  <button class="appui-tbtn" style="margin-right:6px" @click="openEdit(r)">Editar</button>
                  <button class="appui-tbtn appui-tbtn--danger" @click="remove(r)">Excluir</button>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      </template>

      <!-- INDICAÇÕES -->
      <section v-if="activeTab === 'indicacoes'" class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left"><span class="appui-sec-title">Indicações realizadas</span></div>
          <div class="appui-card-toolbar-right">
            <span class="appui-count">{{ indications.length }} no total</span>
            <button class="appui-btn appui-btn--ghost appui-btn--sm" @click="loadIndications()"><i class="mdi mdi-refresh mr-1"></i> Atualizar</button>
          </div>
        </div>
        <div v-if="!indications.length" class="appui-inline-empty">Nenhuma indicação ainda.</div>
        <table v-else class="appui-table">
          <thead><tr><th>Quem indicou</th><th>Indicado</th><th style="width:170px">Quando</th></tr></thead>
          <tbody>
            <tr v-for="i in indications" :key="i.id">
              <td style="font-weight:500;color:#495057">{{ i.indicator ? i.indicator.name : '#' + i.participant_id }}</td>
              <td style="color:#74788d">{{ i.indicated ? i.indicated.name : (i.indicated_email || '—') }}</td>
              <td style="color:#74788d">{{ fmtDate(i.created_at) }}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>

    <b-modal v-model="showModal" :title="form.id ? 'Editar recompensa' : 'Nova recompensa'" hide-footer>
      <form @submit.prevent="save()">
        <div class="form-group"><label>Título *</label><input type="text" class="form-control" v-model="form.title" required></div>
        <div class="row">
          <div class="form-group col-sm-6"><label>Meta de indicações *</label><input type="number" class="form-control" v-model.number="form.target" min="1" required></div>
          <div class="form-group col-sm-6"><label>Qtd. disponível</label><input type="number" class="form-control" v-model.number="form.qty_rewards" min="0"><small class="text-muted">0 = ilimitado</small></div>
        </div>
        <div class="form-group"><label>Link da recompensa</label><input type="url" class="form-control" v-model="form.url_reward" placeholder="https://..."></div>
        <div class="text-right"><button type="button" class="btn btn-light mr-2" @click="showModal = false">Cancelar</button><button type="submit" class="btn btn-primary">Salvar</button></div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

const empty = () => ({ id: null, title: '', target: 1, url_reward: '', qty_rewards: 0 })

export default {
  components: {},
  name: 'app-rewards',
  data () {
    return { activeTab: 'recompensas', rewards: [], indications: [], showModal: false, form: empty() }
  },
  mounted () { this.load() },
  methods: {
    switchTab (tab) { this.activeTab = tab; if (tab === 'indicacoes') this.loadIndications() },
    load () { services.listRewards().then(r => { this.rewards = r.data.data }).catch(() => errorMessage('Falha ao carregar.', 3000)) },
    loadIndications () { services.listIndications().then(r => { this.indications = r.data.data }).catch(() => {}) },
    fmtDate (d) {
      if (!d) return ''
      const dt = new Date(String(d).replace(' ', 'T'))
      if (isNaN(dt)) return d
      return dt.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    },
    openCreate () { this.form = empty(); this.showModal = true },
    openEdit (r) { this.form = { id: r.id, title: r.title, target: r.target, url_reward: r.url_reward, qty_rewards: r.qty_rewards }; this.showModal = true },
    async save () {
      try {
        const payload = { title: this.form.title, target: this.form.target, url_reward: this.form.url_reward || null, qty_rewards: this.form.qty_rewards }
        if (this.form.id) await services.updateReward(this.form.id, payload)
        else await services.createReward(payload)
        this.showModal = false
        successMessage('Recompensa salva.', 2000)
        this.load()
      } catch (e) { errorMessage('Falha ao salvar.', 3000) }
    },
    async toggle (r) { try { await services.rewardStatus(r.id); r.status = r.status ? 0 : 1 } catch (e) { errorMessage('Falha.', 3000) } },
    async remove (r) {
      const ok = await this.$bvModal.msgBoxConfirm(`Remover "${r.title}"?`, { okTitle: 'Remover', cancelTitle: 'Cancelar', okVariant: 'danger' })
      if (!ok) return
      try { await services.deleteReward(r.id); this.load() } catch (e) { errorMessage('Falha ao remover.', 3000) }
    }
  }
}
</script>
